module.exports = __webpack_public_path__ + "static/media/title_19.1b592a2f.svg";